import React from "react";

// Mostra il testo del report giornaliero registri (lo stesso inviato via email)
// colorando le righe: completato in verde, mancante in rosso, parziale in ambra.
export default function DailyReportText({ body }) {
  const lines = (body || "").split("\n");
  return (
    <div className="space-y-1 font-body text-sm" data-testid="daily-report-text">
      {lines.map((line, index) => {
        const text = line.trim();
        if (!text) return <div key={index} className="h-2" />;
        if (index === 0) return <h2 key={index} className="font-heading text-lg font-semibold text-navy">{text}</h2>;
        if (text.startsWith("SEDE:") || text === "ADDETTI") return <h3 key={index} className="mt-2 border-b border-hairline pb-1 font-heading font-semibold uppercase tracking-wide text-navy">{text.replace("SEDE:", "Sede:")}</h3>;
        if (text.startsWith("✔")) return <p key={index} className="pl-2 font-medium text-emerald-700">{text}</p>;
        if (text.startsWith("✘")) return <p key={index} className="pl-2 font-semibold text-red-700">{text}</p>;
        if (text.startsWith("!")) return <p key={index} className="pl-2 font-medium text-amber-700">{text.replace(/^!\s*/, "⚠ ")}</p>;
        if (text.startsWith("- manca:")) return <p key={index} className="pl-8 text-red-700">{text.replace(/^- /, "• ")}</p>;
        if (text.startsWith("- ")) return <p key={index} className={`pl-2 ${text.includes("non ha registrato nulla") ? "font-semibold text-red-700" : text.includes("ancora mancanti") ? "text-amber-700" : "text-emerald-700"}`}>{text.replace(/^- /, "• ")}</p>;
        return <p key={index} className="text-slate-600">{text}</p>;
      })}
    </div>
  );
}
